<div class="container p-4 bg-whitesmoke">
  <app-breadcrumb></app-breadcrumb>
  <!-- Header Row: Only Search and View Toggle -->
  <div class="d-flex align-items-center gap-3 mb-4 flex-wrap">
    <!-- Center: Search Bar (Desktop) -->
    <div class="flex-grow-1 mx-3 d-none d-md-block">
      <div class="search-container">
        <mat-icon class="search-icon">search</mat-icon>
        <input 
          type="text"
          class="form-control rounded-pill search-input"
          placeholder="Search bookmarks..." 
          [(ngModel)]="searchTerm"
        >
      </div>
    </div>
    <!-- Right: View Toggle (Desktop with text, Mobile icons only) -->
    <div class="d-flex align-items-center gap-2 ms-auto">
      <div class="btn-group view-toggle-group rounded-pill overflow-hidden d-none d-md-flex" role="group">
        <button 
          type="button"
          class="btn btn-sm px-3"
          [ngClass]="viewMode === 'grid' ? 'btn-primary active-view' : 'btn-outline-secondary'"
          (click)="viewMode = 'grid'"
          matTooltip="Grid View">
          <mat-icon class="me-1" style="font-size: 18px; width: 18px; height: 18px;">
            {{ viewMode === 'grid' ? 'check_circle' : 'grid_view' }}
          </mat-icon>
          <span>Grid View</span>
        </button>
        <button 
          type="button"
          class="btn btn-sm px-3"
          [ngClass]="viewMode === 'list' ? 'btn-primary active-view' : 'btn-outline-secondary'"
          (click)="viewMode = 'list'"
          matTooltip="List View">
          <mat-icon class="me-1" style="font-size: 18px; width: 18px; height: 18px;">
            {{ viewMode === 'list' ? 'check_circle' : 'view_list' }}
          </mat-icon>
          <span>List View</span>
        </button>
      </div>
      <div class="btn-group view-toggle-group rounded-pill overflow-hidden d-flex d-md-none" role="group">
        <button 
          type="button"
          class="btn btn-sm px-2"
          [ngClass]="viewMode === 'grid' ? 'btn-primary active-view' : 'btn-outline-secondary'"
          (click)="viewMode = 'grid'"
          matTooltip="Grid View">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px;">
            {{ viewMode === 'grid' ? 'check_circle' : 'grid_view' }}
          </mat-icon>
        </button>
        <button 
          type="button"
          class="btn btn-sm px-2"
          [ngClass]="viewMode === 'list' ? 'btn-primary active-view' : 'btn-outline-secondary'"
          (click)="viewMode = 'list'"
          matTooltip="List View">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px;">
            {{ viewMode === 'list' ? 'check_circle' : 'view_list' }}
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
  <!-- Search Bar (Mobile) -->
  <div class="mb-4 d-block d-md-none">
    <div class="search-container">
      <mat-icon class="search-icon">search</mat-icon>
      <input 
        type="text"
        class="form-control rounded-pill search-input"
        placeholder="Search bookmarks..." 
        [(ngModel)]="searchTerm"
      >
    </div>
  </div>
  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <mat-spinner diameter="50" class="mx-auto"></mat-spinner>
    <p class="mt-3 text-muted">Loading your bookmarks...</p>
  </div>
  <!-- Error State -->
  <div *ngIf="error && !loading" class="alert alert-danger">
    <div class="d-flex align-items-center">
      <mat-icon class="me-2">error</mat-icon>
      <div class="flex-grow-1">
        <h6 class="mb-1">Error Loading Bookmarks</h6>
        <p class="mb-0">{{ error }}</p>
      </div>
    </div>
  </div>
  <!-- No Bookmarks State -->
  <div *ngIf="!loading && !error && bookmarksWithCards.length === 0" class="text-center py-5">
    <mat-icon style="font-size: 64px; width: 64px; height: 64px;" class="text-muted">bookmark</mat-icon>
    <h4 class="mt-3">No Bookmarks Found</h4>
    <p class="text-muted">You have not bookmarked any cards yet.</p>
  </div>
  <!-- Grid View -->
  <div *ngIf="!loading && !error && filteredBookmarks.length > 0 && viewMode === 'grid'" class="row g-4">
    <div class="col-12 col-md-6 col-lg-4" *ngFor="let item of filteredBookmarks">
      <div class="business-card-wrapper">
        <div 
          class="business-card" 
          (click)="viewCard(item.card)"
          #cardElement
          [ngStyle]="{
            'background': (item.card?.primary_color_1 && item.card?.primary_color_2)
              ? 'linear-gradient(135deg,' + (item.card?.primary_color_1 || '') + ',' + (item.card?.primary_color_2 || '') + ')'
              : 'linear-gradient(135deg,#ffffff,#f8f9fa)',
            'color': getSmartTextColor(item.card?.primary_color_1 || '#ffffff', item.card?.primary_color_2 || '#f8f9fa')
          }">
          <!-- Status Badge -->
          <div class="card-status-overlay-top">
            <span
              class="status-badge"
              [ngClass]="item.card?.isVerified ? 'verified' : 'not-verified'">
              {{ item.card?.isVerified ? 'Verified' : 'Bookmarked' }}
            </span>
          </div>
          <!-- Vertical Action Buttons -->
          <div class="card-actions-overlay-vertical" (click)="$event.stopPropagation()">
            <button mat-icon-button class="action-btn" (click)="navigateToHandlerLink(item.card); $event.stopPropagation()">
              <mat-icon>visibility</mat-icon>
            </button>
            <button mat-icon-button class="action-btn flip-btn" (click)="flipCard(cardElement); $event.stopPropagation()">
              <mat-icon>flip</mat-icon>
            </button>
          </div>
          <!-- Card Inner (Flip Container) -->
          <div class="card-inner">
            <!-- Front Side -->
            <div class="card-front">
              <div class="card-header">
                <div class="company-logo">
                  <img *ngIf="item.card?.business_info?.companyLogo" [src]="item.card?.business_info?.companyLogo" alt="Company Logo" />
                  <div *ngIf="!item.card?.business_info?.companyLogo" class="logo-placeholder">
                    <mat-icon>business</mat-icon>
                  </div>
                </div>
                <div class="contact-name">
                  <h3>{{ item.card?.contact_info?.contactName }}</h3>
                  <p class="designation">{{ item.card?.contact_info?.jobTitle || item.card?.contact_info?.department }}</p>
                  <p class="designation">{{ item.card?.business_info?.businessName }}</p>
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="card-contact-details">
                <div *ngIf="item.card?.contact_info?.primaryEmail" class="detail-item">
                  <mat-icon>email</mat-icon>
                  <span>{{ item.card?.contact_info?.primaryEmail }}</span>
                </div>
                <div *ngIf="item.card?.contact_info?.primaryPhone" class="detail-item">
                  <mat-icon>phone</mat-icon>
                  <span>{{ item.card?.contact_info?.primaryPhone }}</span>
                </div>
                <div *ngIf="item.card?.contact_info?.whatsappNumber" class="detail-item">
                  <mat-icon>chat</mat-icon>
                  <span>{{ item.card?.contact_info?.whatsappNumber }}</span>
                </div>
              </div>
            </div>
            <!-- Back Side -->
            <div class="card-back">
              <h4>{{ item.card?.business_info?.businessName }}</h4>
              <mat-divider></mat-divider>
              <div *ngIf="item.card?.business_info?.companyAddress" class="detail-item">
                <mat-icon>location_on</mat-icon>
                <span>{{ item.card?.business_info?.companyAddress }}</span>
              </div>
              <div *ngIf="item.card?.business_info?.companyEmail" class="detail-item">
                <mat-icon>email</mat-icon>
                <span>{{ item.card?.business_info?.companyEmail }}</span>
              </div>
              <div *ngIf="item.card?.business_info?.companyWebsite" class="detail-item">
                <mat-icon>language</mat-icon>
                <span>{{ item.card?.business_info?.companyWebsite }}</span>
              </div>
              <div *ngIf="hasSocialLinks(item.card)" class="social-links">
                <span class="fw-semibold mt-2 mb-1">Follow Us</span>
                <div class="detail-item">
                  <mat-icon>share</mat-icon>
                  <a *ngIf="item.card?.social_links?.[0]?.url" [href]="item.card?.social_links?.[0]?.url" target="_blank" (click)="$event.stopPropagation()">
                    {{ item.card?.social_links?.[0]?.platform }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- List View -->
  <div *ngIf="!loading && !error && filteredBookmarks.length > 0 && viewMode === 'list'" class="list-view">
    <mat-card class="mb-3 position-relative" *ngFor="let item of filteredBookmarks" (click)="viewCard(item.card)">
      <mat-card-content class="p-3">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center flex-grow-1">
            <div class="me-3">
              <div class="rounded-circle bg-light d-flex align-items-center justify-content-center" 
                   style="width: 48px; height: 48px;">
                <mat-icon>person</mat-icon>
              </div>
            </div>
            <div class="flex-grow-1">
              <h6 class="mb-1 fw-bold">{{ item.card?.contact_info?.contactName }}</h6>
              <p class="mb-1 text-muted small">{{ item.card?.business_info?.businessName }}</p>
              <div class="d-flex gap-3 small text-muted">
                <span *ngIf="item.card?.contact_info?.primaryEmail">
                  <mat-icon class="align-middle" style="font-size: 16px;">email</mat-icon>
                  {{ item.card?.contact_info?.primaryEmail }}
                </span>
                <span *ngIf="item.card?.contact_info?.primaryPhone">
                  <mat-icon class="align-middle" style="font-size: 16px;">phone</mat-icon>
                  {{ item.card?.contact_info?.primaryPhone }}
                </span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span 
              class="badge"
              [ngClass]="item.card?.isVerified ? 'bg-success' : 'bg-danger'">
              {{ item.card?.isVerified ? 'Verified' : 'Bookmarked' }}
            </span>
            <div class="d-flex flex-column gap-1">
              <button mat-icon-button class="p-1" style="width: 32px; height: 32px;" (click)="navigateToHandlerLink(item.card)" matTooltip="View Card">
                <mat-icon style="font-size: 20px;">visibility</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
